// extracted by mini-css-extract-plugin
module.exports = {"chart":"e_tgb","valueFloat":"e_ugb","bars":"e_vgb","bar":"e_wgb","axis":"e_xgb"};